import "shared/global";
import "components/subnav";
import SeasonDropdownFilter from "components/dropdownFilters/DropdownFilter";

$(document).ready(function() {

    let parentContainer = $('#main-container');
    let filters = null;
    let season = parentContainer.data('season');


    // FILTERS
    if (parentContainer.find('.js-dropdown').length > 0) {

        filters = new SeasonDropdownFilter();
        filters.setMount(parentContainer.find('.js-dropdown'))
            .build();

        season = filters.options[filters.selectedInd].value;


        $(filters).on('filterSelected', (e, index, value) => {
            var origin   = window.location.origin
            var pathName = window.location.pathname;

            if(pathName.includes('/episodes/')){
                const [pathNameRoot, episodePart ] = pathName.split('episodes/')
                pathName = pathNameRoot;
            }
            var pageUrl =  origin+pathName +'episodes/'+ value + '/';
            location.href = pageUrl;
        });

    }

    async function createSubNavForReactTopNav() {
        // Find the hidden input
        const input = document.getElementById('subnav-items');
        if (!input) return;

        // check if input.value string contains &quot; and replace with "
        let subnavData = input.value.replace(/&quot;/g, '"').replace(/\\/g, '');

        // Parse JSON value
        try {
            subnavData = JSON.parse(subnavData);
        } catch (e) {
            console.error('Invalid JSON in #subnav-items');
            return;
        }

        // Build subnav HTML
        const subnav = document.createElement('div');
        subnav.id = 'subnav';
        subnav.className = 'padded-container has-arrows';

        subnav.innerHTML = `
            <div class="line"></div>
            <div class="nav-prev"></div>
            <ul data-ci="subnav" class="subnav__items" aa-region="${subnavData.aaRegion}">
                ${subnavData.items.map((item, idx) => `
                    <li>
                        <a
                            class="${idx === 0 ? 'active': ''}"
                            aria-label="${item.title}"
                            href="${item.href}"
                            aa-link="${item.aaLink}"
                        >
                            ${item.title}
                        </a>
                    </li>
                `).join('')}
            </ul>
            <div class="nav-next"></div>
        `;

        // Insert subnav into topNav component
        const existing = document.getElementById('subnav');
        if (!existing) {
            waitForSubNavContainerAndAppend(subnav);
        }
    }

    function waitForSubNavContainerAndAppend(subnav) {
        let counter = 0;
        const interval = setInterval(() => {
            counter++;
            const subNavContainer = document.getElementById('header-sub-nav');
            if (subNavContainer) {
                subNavContainer.appendChild(subnav);
                clearInterval(interval);
            } else if (counter >= 50) {
                clearInterval(interval);
            }
        }, 100);
    }

    if (CBS.Registry.Features.react_web_components_enabled === true
      && CBS.Registry.Features.react_web_components_topnav === true) {
        createSubNavForReactTopNav();
    }
});




